export default __webpack_public_path__ + "static/integrations_okendo-a873683fd020a0faa6e8f6ad7e772702.png";